<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useFloatingContactStore } from '../../../../../store/contacts/floatingContact.ts';
import Button1XP from '../../../../Button1XP/Button1XP.vue';
import FormInput from '../../../../FormInput/FormInput.vue';
import ContactResults from '../../ContactResults/ContactResults.vue';

export type Props = {
  placeholder?: string;
  validationPattern?: string;
  results?: ContactResultsProps;
};

type ContactResultsProps = InstanceType<typeof ContactResults>['$props'];

defineProps<Props>();
const emit = defineEmits(['submit']);
const stateStore = useFloatingContactStore();
const { isL2, isFinder } = storeToRefs(stateStore);

const code = ref<string | undefined>(undefined);

const submit = () => {
  emit('submit');
};
</script>
<template>
  <div :class="$style.container">
    <template v-if="!isL2">
      <form :class="$style.contactFinderForm" @submit.prevent="submit">
        <FormInput
          id="contactFinder"
          v-model="code"
          aria-label="content finder input"
          :class="$style.searchInput"
          is-white
          :pattern="validationPattern || undefined"
          :placeholder="placeholder"
        />
        <Button1XP
          aria-label="content finder submit"
          button-type="submit"
          :disabled="!code"
          size="s"
          start-icon="arrow_forward"
        ></Button1XP>
      </form>
    </template>
    <div v-if="results && isL2 && isFinder" :class="$style.floatingContactFlyOut">
      <form :class="$style.contactFinderForm" @submit.prevent="submit">
        <FormInput
          id="contactFinder"
          v-model="code"
          aria-label="content finder input"
          :class="$style.searchInput"
          is-white
          :pattern="validationPattern || undefined"
          :placeholder="placeholder"
        />
        <Button1XP
          aria-label="content finder submit"
          button-type="submit"
          :disabled="!code"
          size="s"
          start-icon="arrow_forward"
        ></Button1XP>
      </form>
      <ContactResults :contacts="results.contacts" :title="results.title" />
    </div>
  </div>
</template>

<style lang="sass" module src="./ContactFinderInput.scss" />
